import api from './api';

// 认证服务
export const authService = {
  // 用户注册
  register: async (userData) => {
    try {
      const response = await api.post('/api/account/register', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 用户登录
  login: async (credentials) => {
    try {
      const response = await api.post('/api/account/login', credentials);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 用户注销
  logout: async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const response = await api.post('/api/account/logout', {}, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        return response.data;
      }
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 获取当前用户信息
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // 检查用户是否已登录
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  // 设置认证信息
  setAuth: (token, user) => {
    localStorage.setItem('token', token);
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    }
  },

  // 清除认证信息
  clearAuth: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};